import React from 'react'
import PropTypes from 'prop-types'
import {Button} from 'rambler-ui'
import Popup from 'components/Popup'

export default function AddPhoneOffer({onResolve, onReject, ...props}) {
  return (
    <Popup
      {...props}
      title="Добавление телефона"
      showClose
      okButton={
        <Button type="primary" onClick={onResolve}>
          Добавить
        </Button>
      }
      cancelButton={
        <Button type="outline" onClick={onReject}>
          Не добавлять
        </Button>
      }>
      У вас не указан телефон для восстановления доступа к почте на Рамблере.
      Для защиты вашего профиля рекомендуем добавить его вместо телефона для
      связи. Добавить телефон для восстановления доступа?
    </Popup>
  )
}

AddPhoneOffer.propTypes = {
  onResolve: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired
}
